let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bjHsW")).then(() => parcelRequire('jrWYq'));